"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDivider = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledDivider = exports.StyledDivider = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1eplha7-0"
})(["background-color:", ";vertical-align:middle;position:relative;top:0;.inner{display:inline-block;padding:0 24px;}", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.theme.divider.backgroundColor;
}, function (props) {
  return props.dashed && (0, _ykbStyledComponents.css)(["background:none;border-top:1px dashed ", ";"], function (props) {
    return props.theme.divider.borderColor;
  });
}, function (props) {
  return props.$type === 'vertical' && (0, _ykbStyledComponents.css)(["margin:0 ", ";display:inline-block;height:", ";width:", ";"], function (props) {
    return props.theme.divider.margin;
  }, function (props) {
    return props.theme.divider.vertical.height;
  }, function (props) {
    return props.theme.divider.vertical.width;
  });
}, function (props) {
  return props.$type === 'horizontal' && (0, _ykbStyledComponents.css)(["display:block;height:", ";width:", ";margin:", " 0;clear:both;"], function (props) {
    return props.theme.divider.horizontal.height;
  }, function (props) {
    return props.theme.divider.horizontal.width;
  }, function (props) {
    return props.theme.divider.margin;
  });
}, function (props) {
  return props.$type === 'horizontal' && props.withText && (0, _ykbStyledComponents.css)(["display:table;white-space:nowrap;text-align:center;background:transparent;font-weight:500;color:", ";font-size:", ";margin:16px 0;&:before,&:after{content:'';display:table-cell;position:relative;top:calc(0.75em - 2px);width:50%;border-top:1px solid ", ";}"], function (props) {
    return props.theme.divider.color;
  }, function (props) {
    return props.theme.divider.horizontal.fontSize;
  }, function (props) {
    return props.theme.divider.borderColor;
  });
}, function (props) {
  return props.$orientation !== '' && (0, _ykbStyledComponents.css)([".inner{display:inline-block;padding:0 10px;}"]);
}, function (props) {
  return props.$type === 'horizontal' && props.$orientation === 'left' && (0, _ykbStyledComponents.css)(["&:before{width:5%;}&:after{width:95%;}"]);
}, function (props) {
  return props.$type === 'horizontal' && props.$orientation === 'right' && (0, _ykbStyledComponents.css)(["&:before{width:95%;}&:after{width:5%;}"]);
}, function (props) {
  return props.dashed && props.withText && (0, _ykbStyledComponents.css)(["border-top:0;&:before,&:after{border-style:dashed none none;}"]);
});